import { defineStore } from "pinia";

import axiosConfig from "@/axiosConfig";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthenticated: localStorage.getItem("isAuthenticated") ? JSON.parse(localStorage.getItem("isAuthenticated")) : false,
    user: JSON.parse(localStorage.getItem("user")),
    token: localStorage.getItem("token"),
    expiresAt: localStorage.getItem("expiresAt"),
  }),
  actions: {
    login(email, password) {
      return axiosConfig
        .post("/auth/login", { email, password })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    forgotPassword(email) {
      return axiosConfig
        .post("/auth/reset-password", { email })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    setPassword(token, password, password_confirmation) {
      return axiosConfig
        .post("/auth/set-password", {
          token,
          password,
          password_confirmation,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    acceptInvitation(token, password, password_confirmation) {
      return axiosConfig
        .post(`/auth/invitation/${token}/accept`, {
          token,
          password,
          password_confirmation,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    getInvitationDetail(token) {
      return axiosConfig
        .get(`/auth/invitation/${token}`)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    userData() {
      return axiosConfig
        .get("/profiles/detail")
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    setAuthData(data, user) {
      this.isAuthenticated = true;
      this.token = data.token;
      this.user = user;
      this.expiresAt = data.expires_at;
      localStorage.setItem("token", data.token);
      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("expiresAt", data.expires_at);
    },
    clearAuthData() {
      this.isAuthenticated = false;
      this.token = null;
      this.user = null;
      this.expiresAt = null;
      localStorage.setItem("isAuthenticated", false);
      localStorage.setItem("token", null);
      localStorage.setItem("user", null);
      localStorage.setItem("expiresAt", null);
      localStorage.clear();
    },
    refreshToken() {
      return axiosConfig
        .post("/profiles/refresh-token")
        .then((response) => {
          this.setAuthData(response.data, this.user);
          return response.data;
        })
        .catch((error) => {
          console.error("Token refresh failed:", error);
          // Clear auth data on refresh failure
          this.clearAuthData();
          throw error;
        });
    },
  },
});
